import { isAxiosError } from "axios";

/** The server's message for a failed request, for people to read. */
export const apiErrorMessage = (e: unknown): string => {
  if (isAxiosError<{ message?: unknown }>(e)) {
    const message = e.response?.data?.message;
    if (typeof message === "string") {
      return message;
    }
  }
  return e instanceof Error ? e.message : String(e);
};
